import type { ReactNode } from "react";
import { Icon } from "./Icon";
import "./PageFormShell.css";

/**
 * SAYFA BİÇİMİNDE FORM KABUĞU — `Drawer` ile AYNI prop arayüzü.
 *
 * Amaç: bir formu çekmece yerine tam sayfa (uygulama içi sekme) olarak göstermek, ama
 * formun 500+ satırlık gövdesine HİÇ dokunmamak. Çağıran bileşen yalnız sarmalayıcıyı
 * değiştirir:
 *
 *     const Shell = variant === "page" ? PageFormShell : Drawer;
 *     <Shell open onClose title subtitle footer>…</Shell>
 *
 * Bu yüzden imza bilinçli olarak Drawer'ınkini taklit eder; `size`/`widthPx`/`fullScreen`/
 * `dismissible` kabul edilir ama YOK SAYILIR (sayfa zaten tüm alanı kaplar). Drawer'ın
 * portal/z-index/ESC/odak-tuzağı mekanizmalarının hiçbiri burada gerekmez: içerik sekme
 * panelinin normal akışındadır.
 */
export interface PageFormShellProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  size?: "sm" | "md" | "lg" | "xl" | "xxl" | "3xl";
  widthPx?: number;
  fullScreen?: boolean;
  dismissible?: boolean;
  /**
   * TAM GENİŞLİK. Varsayılan gövde 980px'te durur — tek sütunlu bir kart formunda uzun
   * satır okunmayı zorlaştırır. Ama iki panelli TOPLU GİRİŞ ekranlarında (personel seçimi |
   * tarih-saat tablosu) bu sınır tabloyu ezip yatay kaydırma doğurur; orada sayfanın
   * tamamı kullanılır. Kapatma düğmesi ve başlık aynı kalır.
   */
  wide?: boolean;
}

export function PageFormShell({ open, onClose, title, subtitle, children, footer, wide }: PageFormShellProps) {
  if (!open) return null;
  return (
    <div className="items-page pform">
      {/* Başlık sınıfları BİLİNÇLİ olarak `.title`/`.sub` DEĞİL: sekme kabuğu o iki sınıfı
          gizliyor (sayfa adını sekme çubuğu taşıyor). Form başlığı ise içeriğin parçası —
          "Yeni Stok Kartı" yazısı ekranda kalmalı. */}
      <div className="pform-head">
        <div className="pform-titles">
          <h1 className="pform-title">{title}</h1>
          {subtitle ? <p className="pform-sub">{subtitle}</p> : null}
        </div>
        <button type="button" className="btn-md ghost" onClick={onClose}>
          <Icon name="x" size={14} />Kapat
        </button>
      </div>

      <div className={`pform-body${wide ? " wide" : ""}`}>{children}</div>

      {/* Alt şerit yapışkan: uzun formda kaydet düğmesi hep erişilebilir kalsın —
          çekmecede footer zaten sabitti, sayfada da öyle davranmalı. */}
      {footer ? <div className="pform-foot">{footer}</div> : null}
    </div>
  );
}
